/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.configuration.manager.rpc.MultiAccountReportingConfigurationChirpService
 */

export const getAccountIdsSharingMultiAccountsReportsWithRpc = {
  serviceName: 'com.hubspot.multi.account.configuration.manager.rpc.MultiAccountReportingConfigurationChirpService',
  rpcName: 'getAccountIdsSharingMultiAccountsReportsWith',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAA2Dfqay7y9-MheTORhNAPH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAccountsSharingMultiAccountsReportsWithRpc = {
  serviceName: 'com.hubspot.multi.account.configuration.manager.rpc.MultiAccountReportingConfigurationChirpService',
  rpcName: 'getAccountsSharingMultiAccountsReportsWith',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACjCLvmNdd91cheTORhNAPH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};